import { render, staticRenderFns } from "./ProfilSignature.vue?vue&type=template&id=2f87f820&scoped=true"
import script from "./ProfilSignature.vue?vue&type=script&lang=js"
export * from "./ProfilSignature.vue?vue&type=script&lang=js"
import style0 from "./ProfilSignature.vue?vue&type=style&index=0&id=2f87f820&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f87f820",
  null
  
)

export default component.exports